import { capitalize } from '@mui/material';
import { format, startOfMonth } from 'date-fns';
import { da } from 'date-fns/locale';
import { UseOfForceUnitOverviewItemModel } from '../../api-service/clients';

export interface InterventionMonth {
  key: string;
  label: string;
  items: UseOfForceUnitOverviewItemModel[];
}

// BEK 1411 § 21, stk. 1 reports per month, and a skema belongs to the month of the intervention, not of the approval.
export function groupByInterventionMonth(items: UseOfForceUnitOverviewItemModel[]): InterventionMonth[] {
  const months = new Map<string, InterventionMonth>();
  for (const item of [...items].sort((a, b) => startedAt(a) - startedAt(b))) {
    const start = item.incident.draft.interventionStartedAt;
    const key = start ? format(new Date(start), 'yyyy-MM') : '';
    if (!months.has(key)) {
      months.set(key, { key, label: start ? capitalize(format(new Date(start), 'LLLL yyyy', { locale: da })) : 'Uden dato', items: [] });
    }
    months.get(key)!.items.push(item);
  }
  return [...months.values()];
}

export function isFromEndedMonth(item: UseOfForceUnitOverviewItemModel, now: Date): boolean {
  const start = item.incident.draft.interventionStartedAt;
  return !!start && new Date(start) < startOfMonth(now);
}

function startedAt(item: UseOfForceUnitOverviewItemModel): number {
  const start = item.incident.draft.interventionStartedAt;
  return start ? new Date(start).getTime() : 0;
}
